import isFunction from 'lodash/isFunction';

// eslint-disable-next-line
// @ts-ignore
export function a11yKey(callback, keys = [13]) {
  // eslint-disable-next-line
  // @ts-ignore
  return (event) => {
    if (isFunction(callback) && keys.includes(event.keyCode)) {
      event.preventDefault();
      event.stopPropagation();
      callback(event);
    }
  };
}
